import {
	User
} from "~/node_modules/sitisjs/dist/internal/sections/users/models/User";

export const state = () => ({
	isOpenAuth: false,
	isOpenRegist: false,
});

export const mutations = {
	setOpen: function (state, {name, value}) {
		state[name] = value;
	}
};

export const actions = {
	getUserTransportation: async function ({ commit }) {
		const resUser = await this.$api.agent.transport.get('/users/me?expand=group', {
			baseURL: process.env.transportationApiUrl
		}).then((res) => {
			return new User(res?.data || {});
		}).catch((err) => null);
		this.app.store.commit('user/setUser', resUser);
		this.app.store.commit('user/setLoadingUser', false);
		this.app.store.commit('user/setLoadedSuccess', true);
	},
}
